import { useTextStorage } from "../../../../hooks/TextStorageProvider"
import { Accordion } from "../../../../components"
import "./FaqSection.scss"
import { testimonialDecor, testimonialDecor2 } from "../../../../assets/images"

export const FaqSection: React.FC = () => {
  const { ts } = useTextStorage()

  return (
    <div className="faq-section">
      <h2>{ts.pages.home.faqSection.title}</h2>
      <div className="faq-section__accordion-container">
        {ts.pages.home.faqSection.faqs.map((faq, index) => (
          <Accordion
            key={index}
            title={faq.question}
            description={faq.answer}
            isFirst={index === 0}
          />
        ))}
      </div>
      <img src={testimonialDecor} alt="faq-decor" className="faq-decor" />
      <img src={testimonialDecor2} alt="faq-decor" className="faq-decor2" />
    </div>
  )
}
